import { LoadingButton } from "@mui/lab";
import { Box, Button, Modal, Typography } from "@mui/material";

export const ModalAcceptInvestment = ({
  modalOpenAccept,
  setModalOpenAccept,
  isLoadingButton,
  handleAcceptInvestment,
}) => {
  return (
    <Modal open={modalOpenAccept}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 350,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 4,
          p: 2,
        }}
      >
        <Typography component="h6" mb={1}>
          Confirmación
        </Typography>
        <Typography component="span" fontWeight="normal">
          ¿Quieres aceptar esta inversión?
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
          <Button
            disabled={isLoadingButton ? true : false}
            variant="outlined"
            sx={{ boxSizing: "border-box", width: 130, px: 1 }}
            onClick={() => setModalOpenAccept(false)}
          >
            Cancelar
          </Button>
          <LoadingButton
            loading={isLoadingButton}
            variant="contained"
            sx={{
              boxSizing: "border-box",
              color: "white",
              width: 130,
              px: 1,
            }}
            onClick={handleAcceptInvestment}
          >
            Aceptar
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export const ModalRejectInvestment = ({
  modalOpenReject,
  setModalOpenReject,
  isLoadingButton,
  handleRejectInvestment,
}) => {
  return (
    <Modal open={modalOpenReject}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 350,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 4,
          p: 2,
        }}
      >
        <Typography component="h6" mb={1}>
          Confirmación
        </Typography>
        <Typography component="span" fontWeight="normal">
          ¿Quieres rechazar esta inversión?
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
          <Button
            disabled={isLoadingButton ? true : false}
            variant="outlined"
            sx={{ boxSizing: "border-box", width: 130, px: 1 }}
            onClick={() => setModalOpenReject(false)}
          >
            Cancelar
          </Button>
          <LoadingButton
            loading={isLoadingButton}
            variant="contained"
            sx={{
              boxSizing: "border-box",
              color: "white",
              width: 130,
              px: 1,
            }}
            onClick={handleRejectInvestment}
          >
            Aceptar
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export const ModalDisableInvestment = ({
  modalOpenAccept,
  setModalOpenAccept,
  isLoadingButton,
  handleDisableInvestment,
}) => {
  return (
    <Modal open={modalOpenAccept}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 350,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 4,
          p: 2,
        }}
      >
        <Typography component="h6" mb={1}>
          Confirmación
        </Typography>
        <Typography component="span" fontWeight="normal">
          ¿Quieres deshabilitar esta inversión?
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
          <Button
            disabled={isLoadingButton ? true : false}
            variant="outlined"
            sx={{ boxSizing: "border-box", width: 130, px: 1 }}
            onClick={() => setModalOpenAccept(false)}
          >
            Cancelar
          </Button>
          <LoadingButton
            loading={isLoadingButton}
            variant="contained"
            sx={{
              boxSizing: "border-box",
              color: "white",
              width: 130,
              px: 1,
            }}
            onClick={handleDisableInvestment}
          >
            Aceptar
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};

export const ModalContactedClient = ({
  modalOpenAccept,
  setModalOpenAccept,
  isLoadingButton,
  handleDisableInvestment,
}) => {
  return (
    <Modal open={modalOpenAccept}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 350,
          bgcolor: "white",
          borderRadius: 3,
          boxShadow: 4,
          p: 2,
        }}
      >
        <Typography component="h6" mb={1}>
          Confirmación
        </Typography>
        <Typography component="span" fontWeight="normal">
          Este cliente será marcado como contactado
        </Typography>
        <Box display="flex" justifyContent="flex-end" gap={1} mt={3}>
          <Button
            disabled={isLoadingButton ? true : false}
            variant="outlined"
            sx={{ boxSizing: "border-box", width: 130, px: 1 }}
            onClick={() => setModalOpenAccept(false)}
          >
            Cancelar
          </Button>
          <LoadingButton
            loading={isLoadingButton}
            variant="contained"
            sx={{
              boxSizing: "border-box",
              color: "white",
              width: 130,
              px: 1,
            }}
            onClick={handleDisableInvestment}
          >
            Aceptar
          </LoadingButton>
        </Box>
      </Box>
    </Modal>
  );
};
